import { FlexibleModuleEnum } from 'generated/graphql';
import type { PageBuilderModuleType } from '~/modules/page-builder/types';
import SingleImageModule from '~/modules/page-builder/component/detail/single-image-module/SingleImageModule';

import DuoParagraphModule from '../duo-paragraph-module/DuoParagraphModule';
import DuoImageModule from '../duo-image-module/DuoImageModule';
import SingleParagraphModule from '../single-paragraph-module/SingleParagraphModule';
import ImageParagraphModule from '../image-paragraph-module/ImageParagraphModule';
import GalleryModule from '../gallery-module/GalleryModule';
import SingleVideoModule from '../single-video-module/SingleVideoModule';
import VideoParagraphModule from '../video-paragraph-module/VideoParagraphModule';
import QuoteModule from '../quote-module/QuoteModule';

interface DetailModuleProps {
    module: PageBuilderModuleType;
    autoPlayVideoModuleId?: string;
}

/**
 * A rendered Page Builder module on the website. The module component rendered
 * depends on the module type.
 */
const DetailModule = ({ module, autoPlayVideoModuleId }: DetailModuleProps) => {
    const columns = module.columns;
    const meta = module.meta;

    const firstColumn = columns[0];
    if (!firstColumn) {
        return null;
    }

    switch (module.presetType) {
        case FlexibleModuleEnum.ImageParagraphModule:
            return <ImageParagraphModule columns={columns} meta={meta} />;
        case FlexibleModuleEnum.VideoParagraphModule:
            return <VideoParagraphModule columns={columns} meta={meta} />;
        case FlexibleModuleEnum.SingleVideoModule:
            return (
                <SingleVideoModule
                    column={firstColumn}
                    shouldAutoPlayVideo={autoPlayVideoModuleId === module.id}
                    isCoverGrayscale={module.isCoverGrayscale}
                />
            );
        case FlexibleModuleEnum.HeadingModule:
        case FlexibleModuleEnum.SingleParagraphModule:
            return <SingleParagraphModule column={firstColumn} meta={meta} />;
        case FlexibleModuleEnum.DuoParagraphModule:
            return <DuoParagraphModule columns={columns} meta={meta} />;
        case FlexibleModuleEnum.QuoteModule:
            return <QuoteModule column={firstColumn} meta={meta} />;
        case FlexibleModuleEnum.SingleImageModule:
            return <SingleImageModule column={firstColumn} />;
        case FlexibleModuleEnum.DuoImageModule:
            return <DuoImageModule columns={columns} />;
        case FlexibleModuleEnum.QuadImageModule:
        case FlexibleModuleEnum.OctaImageModule:
            return <GalleryModule columns={columns} />;
        default:
            return null;
    }
};

export default DetailModule;
